// extracted by mini-css-extract-plugin
export default {"leftIndicator":"styles_leftIndicator__fibre","rightIndicator":"styles_rightIndicator__xp67o","material-icons":"styles_material-icons__eTcyb","contrast":"styles_contrast__veNzp"};